import React from 'react'

const BloomDisclaimer = () => {
    return (
        <div className="bloom-disclaimer">
            <p>
                Bloom Season may contain content for mature audiences, and the views, thoughts and opinions expressed are those of the writers and interviewees and may not necessarily represent those of Intuit Mailchimp. The material and information presented is for general information purposes only, and information provided should not be considered legal advice or a substitute for obtaining such advice specific to you.
            </p>
            
            <style jsx>{`
                div {
                    padding: 40px 60px;
                    background: #f2f2f2;
                }
                p {
                    font-size: 12px;
                    font-style: italic;
                    text-align: center;
                    line-height: 1.4;
                }

                @media (max-width: 769px), (pointer: coarse) {
                    div {
                        padding: 40px 20px;
                    }
                    p {
                        font-size: 10px;
                    }
                }
            `}</style>
        </div>
    )
}

export default BloomDisclaimer